<template>
  <div id="tempcreate-layer">
    <light-header :back="backUrl"></light-header>
    <div class="tempcreate-content auto">
      <div class="tempcreate-files">
        <h3 class="tempcreate-title">
          <span>个人实名认证</span>
        </h3>
        <div style="display: flex; flex-wrap: wrap" id="company-info-layer">
          <div style="width: 100%">
            <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">
              <el-divider content-position="center"
                >根据《中华人民共和国电子签名法》要求签署方身份信息真实，请您完成个人认证，如没有完成个人实名认证将不能签署合同。</el-divider
              >
            </div>
          </div>
        </div>
        <div v-if="!authOk">
          <el-form
            :model="filesForm"
            ref="filesForm"
            label-width="200px"
            label-position="right"
            class="files-Form"
            v-if="!authId"
          >
            <div style="width: 80%; margin: 15px auto">
              <el-form-item
                prop="idName"
                label="姓名"
                :rules="[
                  {
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur',
                  },
                  { validator: checkChinese, trigger: 'blur' },
                ]"
              >
                <el-input
                  maxlength="20"
                  v-model="filesForm.idName"
                  placeholder="请输入姓名"
                  style="width: 70%"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="idNumber"
                label="身份证号"
                :rules="[
                  {
                    required: true,
                    message: '请输入身份证号',
                    trigger: 'blur',
                  },
                  { validator: checkID, trigger: 'blur' },
                ]"
              >
                <el-input
                  maxlength="18"
                  v-model="filesForm.idNumber"
                  placeholder="请输入身份证号"
                  style="width: 70%"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div v-else>
            <div style="text-align: center">
              <img :src="authCodeImg" alt="" />
            </div>
            <div class="qrcode-tip" v-if="!qrCodeOutDated">
              请扫描二维码完成个人实名认证
            </div>
            <div class="qrcode-tip" v-else>二维码已失效！请重新获取</div>
          </div>
        </div>

        <el-result
          v-else
          icon="success"
          title="个人认证成功"
          subTitle="返回首页进行更多操作"
        >
          <template slot="extra"> </template>
        </el-result>
      </div>
    </div>
    <div class="tempcreate-users-box auto">
      <div v-if="!authOk">
        <div class="sign-btns" v-if="!authId">
          <el-button
            type="primary"
            @click="handleSavePersonalInfo"
            :disabled="formLoading"
            :loading="formLoading"
            >提 交</el-button
          >
        </div>
        <div class="sign-btns" v-else>
          <el-button type="primary" @click="handleRefreshAuthQrcode"
            >重新获取</el-button
          >
        </div>
      </div>
      <div class="sign-btns" v-else>
        <el-button type="primary" @click="handleBackHome">返回首页</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import { Loading } from "element-ui";

import lightHeader from "@/components/lightHeader";
import { getPersonAuthLink, getPersonAuthResult } from "@/api/auth/auth";
export default {
  components: {
    lightHeader,
  },
  computed: {
    backUrl() {
      if (this.$route.query.from) {
        return this.$route.query.from.replace(/\!\!/g, "?");
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      formLoading: false,

      filesForm: {
        idName: "",
        idNumber: "",
      },

      authCodeImg: "",
      authId: "",
      timer: null,
      authOk: false,
      qrCodeOutDated: false,

      checkID: (rule, value, callback) => {
        let idcard_patter =
          /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
        if (!idcard_patter.test(value)) {
          callback(new Error("身份证号输入有误！"));
        } else {
          callback();
        }
      },
      checkChinese: (rule, value, callback) => {
        var reg = /^[\u0391-\uFFE5]+$/;
        if (!reg.test(value)) {
          callback(new Error("只能输入中文！"));
        } else {
          callback();
        }
      },
    };
  },
  created() {},
  beforeRouteLeave(to, from, next) {
    if (this.timer) {
      setTimeout(() => {
        clearInterval(this.timer);
        this.timer = null;
      }, 0);
    }
    if (this.outTimer) {
      clearTimeout(this.outTimer);
      this.outTimer = null;
    }
    next();
  },
  methods: {
    handleSavePersonalInfo() {
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.handleGetPersonAuthLink();
        }
      });
    },
    handleGetPersonAuthLink() {
      getPersonAuthLink({
        idName: this.filesForm.idName,
        idNumber: this.filesForm.idNumber,
        callbackUrl: "",
        needQrcode: "yes",
      })
        .then((res) => {
          this.formLoading = false;
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.authCodeImg = res.data.authLinkQrcodeBase64;
            this.authId = res.data.authId;
            this.pollingResult();
          }
        })
        .catch((err) => {
          this.formLoading = false;
          console.log(err);
        });
    },
    handleRefreshAuthQrcode() {
      this.handleGetPersonAuthLink();
    },
    pollingResult() {
      this.qrCodeOutDated = false;
      this.timer = setInterval(this.getAuthResultHandle, 3000);
      this.outTimer = setTimeout(() => {
        clearInterval(this.timer);
        this.timer = null;
        this.qrCodeOutDated = true;
      }, 1000 * 60 * 5);
    },
    getAuthResultHandle() {
      getPersonAuthResult({
        authId: this.authId,
      })
        .then((res) => {
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            if (res.data.status === "pass") {
              this.authOk = true;
              clearInterval(this.timer);
              this.timer = null;
            } else if (res.data.status === "notAuth") {
              this.authOk = false;
              this.$message({
                showClose: true,
                message: "实人认证失败，请重试",
                type: "warning",
              });
              clearInterval(this.timer);
              this.timer = null;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleBackHome() {
      this.$router.replace("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.tempcreate-content {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-top: 30px;

  .tempcreate-files {
    background: #ffffff;
    overflow: hidden;
    padding: 27px 27px;
    .tempcreate-title {
      height: 23px;
      line-height: 23px;
      font-size: 18px;
      color: #333333;
      border-left: 3px solid #3296fa;
      text-indent: 10px;
      font-weight: 400;
      margin-bottom: 22px;
    }
    label {
      width: 98px;
      color: #666666;
      display: inline-block;
    }
  }
}
.tempcreate-users-box {
  padding: 15px 40px;
  background: #ffffff;
  margin-top: 18px;

  .add-btn {
    padding: 11px 14px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: #ffffff;
  }

  .sign-btns button.sign-button {
    padding: 12px 18px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }
}
#tempcreate-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

// .tempcreate-content {
// 	width: 1200px;
// 	margin: 30px auto;
// }

.sign-btns {
  width: 718px;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.sign-btns button {
  width: 140px;
  height: 45px;
  font-size: 14px;
}

#invoice-info-layer .el-form-item /deep/ .el-input__inner,
#invoice-info-layer .el-form-item /deep/ .el-form-item__content,
#invoice-info-layer .el-form-item /deep/ .el-date-editor,
#company-info-layer .el-form-item /deep/ .el-input__inner,
#company-info-layer .el-form-item /deep/ .el-form-item__content,
#company-info-layer .el-form-item /deep/ .el-date-editor {
  width: 300px !important;
}

h4 {
  padding: 10px 0 30px;
  text-align: center;
}
.el-divider /deep/ .el-divider__text {
  color: #999;
  text-align: center;
}

#auth-info-company-layer .el-form-item__label {
  font-size: 18px;
  line-height: 48px;
}

#auth-info-company-layer .submit {
  width: 363px;
  height: 50px;
  margin: 60px auto 0;
  font-size: 18px;
  margin-bottom: 96px;
}

#auth-info-company-layer .el-form-item {
  width: 55%;
  margin: 0 auto 20px;
}

#auth-info-company-layer .el-form-item /deep/ .el-form-item__label {
  width: 100% !important;
  text-align: center;
}

.qrcode-tip {
  color: #000;
  font-size: 14px;
  text-align: center;
}
</style>